import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'
import {remCalc} from '../../_utils'

const helpers = createMultiStyleConfigHelpers([
    'container',
    'title',
    'containerBreakpoint',
    'image',
    'titleBreakpoint',
    'subtitle',
    'secondaryTitle',
    'imageLarge',
])

export const createGradientBackground = (imageUrl: string) => ({
    background: `
    linear-gradient(180deg, rgba(0, 0, 0, 0.00) 55%, rgba(0, 0, 0, 0.60) 84.62%), 
    url(${imageUrl}) center / cover no-repeat
  `,
})

const ListMenuCard = helpers.defineMultiStyleConfig({
    baseStyle: {
        container: {
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            // boxShadow: 'borderShadow',
            background: 'background.light',
        },
        title: {textDecoration: 'none'},
        image: {
            overflow: 'hidden',
        },
        // img: {
        //     height: '100%',
        // },
    },
    variants: {
        default: {
            container: {
                w: {base: remCalc(163), lg: remCalc(213)},
                h: {base: remCalc(183), lg: remCalc(233)},
                pt: {base: remCalc(16), lg: remCalc(40)},
                display: 'flex',
                flexDirection: 'column',
                gap: {base: remCalc(2), lg: remCalc(8)},
                alignItems: 'center',
                _hover: {
                    '& .chakra-text:first-of-type': {
                        color: 'text.tertiary',
                    },
                },
            },
            title: {
                textStyle: {base: 'head-xxsmall'},
                px: remCalc(8),
                color: 'text.default',
                fontWeight: '600',
                textAlign: 'center',
            },
            subtitle: {
                px: remCalc(8),
                textStyle: 'body-xsmall',
                color: 'text.default',
                textAlign: 'center',
            },
            image: {
                w: {base: remCalc(92), lg: remCalc(118)},
                h: {base: remCalc(92), lg: remCalc(118)},
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
        },
        defaultLarge: {
            container: {
                w: {base: remCalc(163), md: remCalc(225.75), lg: remCalc(213)},
                h: {base: remCalc(183), md: remCalc(233), lg: remCalc(233)},
                pt: {base: remCalc(8)},
                display: 'flex',
                flexDirection: 'column',
                gap: {base: remCalc(14), lg: remCalc(22)},
                alignItems: 'center',
                _hover: {
                    '& .chakra-text:first-of-type': {
                        color: 'text.tertiary',
                    },
                },
            },
            title: {
                px: remCalc(8),
                textStyle: {base: 'body-small', lg: 'head-xxsmall'},
                color: 'text.default',
                fontWeight: '600',
                textAlign: 'center',
            },
            subtitle: {
                px: remCalc(8),
                textStyle: 'body-xsmall',
                color: 'text.default',
            },
            image: {
                w: {base: remCalc(140), lg: remCalc(181)},
                h: {base: remCalc(118), lg: remCalc(153)},
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
        },
        filter: {
            container: {
                w: {lg: remCalc(377)},
                h: {base: remCalc(164), md: remCalc(183), lg: remCalc(233)},
                pos: 'relative',
                overflow: 'hidden',
                p: remCalc(16),
                display: 'flex',
                flexDirection: 'column',
                gap: remCalc(8),
            },
            title: {
                textStyle: 'body-small',
                pos: 'absolute',
                textDecoration: 'underline',
                bottom: {base: remCalc(14), lg: remCalc(16)},
                left: {base: remCalc(14), lg: remCalc(16)},
                px: remCalc(10),
                color: 'text.inverse',
                textAlign: 'left',
                fontWeight: '600',
                w: '100%',
            },
            subtitle: {
                color: 'text.inverse',
                textStyle: 'head-xxsmall',
                fontWeight: '600',
                pos: 'relative',
            },
            secondaryTitle: {
                color: 'text.inverse',
                textStyle: 'head-small',
                fontWeight: '600',
                pos: 'relative',
                w: '60%',
            },
            image: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                h: '100%',
                w: '100%',
            },
        },
        promo: {
            container: {
                w: {xl: remCalc(407), '2xl': remCalc(442)},
                h: {base: remCalc(164), md: remCalc(183), lg: remCalc(233)},
                pos: 'relative',
                overflow: 'hidden',
                p: remCalc(16),
                display: 'flex',
                flexDirection: 'column',
                gap: remCalc(8),
            },
            // containerBreakpoint: {
            //     '@media (min-width: 1024px) and (max-width: 1200px)': {
            //         w: '100%',
            //     },
            // },
            title: {
                textStyle: 'body-small',
                pos: 'absolute',
                textDecoration: 'underline',
                bottom: {base: remCalc(14), lg: remCalc(16)},
                left: {base: remCalc(14), lg: remCalc(16)},
                px: remCalc(10),
                color: 'text.inverse',
                textAlign: 'left',
                fontWeight: '600',
                w: '100%',
            },
            subtitle: {
                color: 'text.inverse',
                textStyle: 'head-xxsmall',
                fontWeight: '600',
                pos: 'relative',
            },
            secondaryTitle: {
                color: 'text.inverse',
                textStyle: 'head-small',
                fontWeight: '600',
                pos: 'relative',
                w: '60%',
            },
            // titleBreakpoint: {
            //     '@media (min-width: 1024px) and (max-width: 1200px)': {
            //         bottom: remCalc(14),
            //     },
            // },
            image: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                h: '100%',
                w: '100%',
            },
        },
        simpleLink: {
            container: {
                w: {base: '100%'},
                h: remCalc(120),
                pos: 'relative',
                overflow: 'hidden',
            },
            title: {
                textStyle: 'body-small',
                pos: 'absolute',
                fontWeight: 'bold',
                left: remCalc(16),
                top: remCalc(12),
                color: 'text.inverse',
                textAlign: 'center',
            },
            image: {h: '100%', w: '100%'},
        },
        exploreAll: {
            container: {
                w: {base: remCalc(163), lg: remCalc(213)},
                h: {base: remCalc(183), lg: remCalc(233)},
                pos: 'relative',
                overflow: 'hidden',
                p: remCalc(16),
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: remCalc(8),
            },
            title: {
                textStyle: 'body-xxlarge',
                bottom: {base: remCalc(14), lg: remCalc(16)},
                left: {base: remCalc(14), lg: remCalc(16)},
                px: remCalc(10),
                color: 'text.inverse',
                textAlign: 'center',
                fontWeight: '600',
                w: '100%',
                zIndex: 5,
            },
            image: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                h: '100%',
                w: '100%',
            },
        },
    },
})

export default ListMenuCard
